import PropTypes from 'prop-types'
import { forwardRef } from 'react'

import Link from './Link'
import OutboundLink from './OutboundLink'

import { domainRegex, redirectPathsRegex } from '~utils/helpers'

/* eslint-disable jsx-a11y/anchor-has-content */
const TextLink = forwardRef(({ href, ...rest }, ref) => {
  const sameDomain = domainRegex.test(href)

  if (sameDomain) {
    href = href.replace(domainRegex, '/')
  }

  if (href.startsWith('/')) {
    // Treat partial URLs that have Netlify redirects as normal links
    if (redirectPathsRegex.test(href)) {
      return <a data-link-default ref={ref} href={href} {...rest} />
    }

    return <Link ref={ref} data-link-internal to={href} {...rest} />
  }

  // Treat urls that aren't web protocols as "normal" links
  if (!href.startsWith('http')) {
    return <a data-link-default ref={ref} href={href} {...rest} /> // eslint-disable-line jsx-a11y/anchor-has-content
  }

  return <OutboundLink ref={ref} href={href} {...rest} />
})
/* eslint-enable jsx-a11y/anchor-has-content */

TextLink.propTypes = {
  href: PropTypes.string.isRequired,
}

export default TextLink
